import { render, staticRenderFns } from "./IslandDetail.vue?vue&type=template&id=dce245c6&"
import script from "./IslandDetail.vue?vue&type=script&lang=js&"
export * from "./IslandDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports